export default __webpack_public_path__ + "static/media/img-gt-mode-on-bg-na_en@2x.2a0c4fb8.jpg";